<template>
    <div>
        <new-pro-popup
            :data-to-show="isNewProPopupDisplayed"
            @close="changeStateNewProPopup(false)"
            @addPro="(newValue) => {addNewPro(newValue)}"
            @modifyPro="(newValue) => {modifyPro(newValue)}"
            :pro-to-edit="pros[indexProToEdit]"
        />

        <h3 class="my-15 mx-10">Expériences</h3>

        <div v-if="pros.length === 0">
            <h6 class="mx-15 text-gray-600">
                Aucune expérience professionnelle n'a été renseignée sur votre Neopass.
            </h6>
            <h6 class="mx-15 text-gray-600 mt-5">
                Pour mettre en avant vos expériences professionnelles, cliquer sur le bouton "ajouter une nouvelle expérience"
            </h6>

            <div class="flex justify-center mt-15">
                <action-button
                    border-color="border-transparent"
                    text-color="text-white"
                    bg-color="bg-indigo-600"
                    bg-color-square="bg-indigo-600"
                    icon-color="text-white"
                    libelle="Ajouter une nouvelle expérience"
                    :uppercase="true"
                    icon="plus-circle"
                    typeShadow="indigo-shadow"
                    @clickAction="isNewProPopupDisplayed = true"
                />
            </div>

            <div class="flex justify-center mt-10">
                <illustration name="evaluation" />
            </div>
        </div>

        <div v-if="pros.length > 0">
            <add-button
                class="mb-8 mx-10"
                libelle="Ajouter une nouvelle expérience"
                @add="isNewProPopupDisplayed = true"
            />

            <draggable
                v-model="form.data.pros"
                v-bind="dragOptions"
                @end="drag= false"
                @start="drag=true"
                handle=".handle"
            >
                <transition-group
                    enter-active-class="ease-in duration-1000"
                    enter-class="bg-indigo-300 border-0 rounded-xl"
                    enter-to-class="bg-none border-0 rounded-xl"
                    leave-active-class="linear duration-1000"
                    leave-class="h-20 opacity-100"
                    leave-to-class="h-0 opacity-0"
                    tag="div"
                >
                    <div
                        v-for="(pro, i) in [...pros, ...newPros]" :key="'pro'+i"
                        class="grid grid-cols-10 gap-x-4 py-5 odd:bg-gray-200 items-center"
                        :class="pro.value.new ? ' odd:bg-opacity-25' : ' odd:bg-opacity-50'"
                    >
                        <div class="col-span-2 justify-self-center handle" :class="pro.value.new ? ' opacity-25' : ''">
                            <icon name="move" class="text-indigo-600 w-5 h-5 cursor-move" />
                        </div>
                        <div class="col-span-5 md:col-span-6 grid grid-cols-12 items-center">
                            <div class="col-span-2">
                                <CVNewValue
v-if="changedPros[pro.value.type+pro.value.value.intitule_parcours] || pro.value.new"
                                    :old="newer.data.parcours[pro.value.type+pro.value.value.intitule_parcours]"
                                    @change="(newValue) => {pro.value = replaceValues(pro.value, newValue); newer.data.parcours[pro.value.type+pro.value.value.intitule_parcours] = false}"
                                    @addNew="(newValue) => {importFromNeopass(newValue)}"
                                    :right="false"
                                    :is-new="pro.value.new"
                                />
                            </div>
                            <div class="col-span-10" :class="pro.value.new ? ' opacity-25' : ''">
                                <p class="text-base font-normal">{{(pro.value.type === "Stage") ? (pro.value.type+((pro.value.value.intitule_parcours) ? ' - ' : '')) : ''}}{{(pro.value.value.intitule_parcours) ? pro.value.value.intitule_parcours : ''}}</p>
                                <p class="text-base font-light">
                                    {{
                                        (pro.value.value.localisation_parcours)
                                            ? pro.value.value.localisation_parcours+((pro.value.value.localisation_parcours && pro.value.value.structure_accueil_parcours) ? " - " : "")+((pro.value.value.structure_accueil_parcours) ? pro.value.value.structure_accueil_parcours : '')
                                            : ""
                                    }}
                                </p>
                                <p class="text-sm italic font-light">
                                    {{(pro.value.value.debut_parcours) ? new Date(pro.value.value.debut_parcours).toLocaleDateString()+' - ' : ''}}
                                    {{
                                        (pro.value.value.fin_parcours)
                                            ? new Date(pro.value.value.fin_parcours).toLocaleDateString()
                                            : (pro.value.value.debut_parcours)
                                                ? "à aujourd'hui"
                                                : ''
                                        }}
                                </p>
                            </div>
                        </div>
                        <div class="col-span-3 md:col-span-2 flex space-x-3">
                            <radio-button
                                :name="'pro_'+i+'_display'"
                                :value="(((((form || {}).data || {}).pros || [])[i] || {}).isDisplayed || false)"
                                @input="(newValue) => {((((form || {}).data || {}).pros || [])[i] || {}).isDisplayed = newValue;}"
                                @loseFocus="saveDatas()"
                            />
                            <div
                                v-if="!pro.fromNeopass"
                                class="cursor-pointer px-2 relative"
                                @click.stop="displayMenuMore(i)"
                            >
                                <icon name="more-vertical" class="text-pink-600" />
                                <div
                                    v-if="menuMoreDisplayed === i"
                                    v-click-outside="hideMenuMore"
                                    class="absolute text-gray-600 bg-white px-5 py-4 rounded-xl shadow-lg flex flex-col space-y-2 text-sm -right-full z-10"
                                >
                                    <p @click.stop="displayModifyProPopup(i)" class="hover:text-gray-900 cursor-pointer">Modifier</p>
                                    <p @click.stop="removePro(i)" class="hover:text-gray-900 cursor-pointer">Supprimer</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </transition-group>
            </draggable>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ClickOutside from 'vue-click-outside';
import draggable from 'vuedraggable';

import NewProPopup from './../popup/NewProPopup.vue';

import Icon from './../../../components/Icon.vue';
import AddButton from './../../../components/Inputs/AddButton.vue';
import RadioButton from './../../../components/Inputs/RadioButton.vue';

import ActionButton from './../../../components/ActionButton.vue';
import Illustration from './../../../components/Illustration.vue';
import CVNewValue from './CVNewValue';

export default {
  components:{
    CVNewValue,
    AddButton,
    Icon,
    RadioButton,
    NewProPopup,
    draggable,
    ActionButton,
    Illustration

  },

  data(){
    return {
      isNewProPopupDisplayed: false,
      menuMoreDisplayed: -1,
      indexProToEdit:-1,
      recursiveMaxDepth: 50,
      recursiveDepth: 0,
    };
  },

  methods:{
    ...mapActions({
      'saveDatas' : 'curriculumVitae/saveDatas'
    }),

    importFromNeopass(item){
      delete item.value.new;
      delete this.newer.data.parcours[item.value.type+item.value.value.intitule_parcours];
      this.form.data.pros.push(item);
    },
    changeStateNewProPopup(state){
      if(!state){
        this.indexProToEdit = -1;
      }
      this.isNewProPopupDisplayed = state;
    },

    addNewPro(value){
      this.form.data.pros.push(
        {
          fromNeopass: false,
          isDisplayed: true,
          value:{
            type:'Expérience',
            value:value
          }
        }
      );

      //this.saveDatas();
    },

    displayMenuMore(num){
      this.menuMoreDisplayed = num;
    },

    hideMenuMore(){
      this.menuMoreDisplayed = -1;
    },

    displayModifyProPopup(num){
      this.indexProToEdit = num;
      this.changeStateNewProPopup(true);
      this.hideMenuMore();
    },

    removePro(num){
      this.form.data.pros.splice(num, 1);
      //this.saveDatas();
      this.hideMenuMore();
    },

    modifyPro(newValue){
      this.form.data.pros[this.indexProToEdit].value.value = newValue;
      this.indexProToEdit = -1;
    },

    mapProValues(entry, res = []){
      if (this.recursiveDepth === this.recursiveMaxDepth){
        return;
      }
      this.recursiveDepth++;
      for (const key in entry){
        const type = typeof entry[key];
        if(type === 'object' || type === 'array'){
          res = this.mapProValues(entry[key], res);
        }else {
          res.push(entry[key]);
        }
      }
      this.recursiveDepth--;
      return res;
    },

    replaceValues(old, _new){
      if (!_new) return old;
      switch (_new.constructor){
      case Object:
        for (const key in _new) {
          old[key] = this.replaceValues(old[key], _new[key]);
        }
        break;
      case Array:
        for (const key in _new) {
          if (old[key] === undefined){
            old[key] = _new[key];
            continue;
          }
          old[key] = this.replaceValues(old[key], _new[key]);
        }
        break;
      default:
        return _new;
      }

      return old;
    },

    *traverse(t){
      switch (t?.constructor){
      case Object:
        for (const k in t)
          (yield [k, t[k]], yield *this.traverse(t[k]));

        break;
      default:
        return;
      }
    }
  },

  computed:{
    ...mapGetters({
      'form' : 'curriculumVitae/form',
      'newer' : 'curriculumVitae/newForm',
      'backdoor' : 'app/backdoor'
    }),

    pros(){
      return (typeof(this.form.data.pros) === 'object') ? Object.values(this.form.data.pros) : this.form.data.pros;
    },


    changedPros(){
      let result = {};
      this.pros.forEach((pro) => {
        const type = pro.value.type;
        const intitule = pro.value.value.intitule_parcours;
        const f = this.newer.data.parcours[type+intitule];
        const mappedValues = this.mapProValues(f);
        result[type+intitule] = mappedValues.some(value => value !== false);
      });

      return result;
    },

    newPros(){
      let result = [];
      this.backdoor;
      for (const key in this.newer.data.parcours){
        const parcour = this.newer.data.parcours[key];
        if(parcour.type === 'Parcours professionnel' ||parcour.type === 'Stage'){
          parcour.new = true;
          result.push({fromNeopass: true, isDisplayed: false, value: parcour});
        }
      }
      return result;
    },

    dragOptions() {
      return {
        animation: 500,
        ghostClass: 'bg-indigo-300'
      };
    }
  },

  watch:{
    form: {
      handler() {
        this.saveDatas();
      },
      deep: true,
    },
  },

  directives: {
    ClickOutside
  }
};
</script>
